import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { tap } from "rxjs/operators";

@Injectable()
export class ProductRequestService {
  constructor(private http: HttpClientService) {}

  getLogger(resource_class, resource_id) {
    const options = {
      params: {
        resource_class: resource_class,
        resource_id: resource_id,
      },
    };
    return this.http
      .get("/api/product_request/logger", options)
      .pipe(tap((_) => console.log("ProductRequestService.getLogger: Ok.")));
  }

  update(resource_class, resource_id, product) {
    const options = {
      resource_class: resource_class,
      resource_id: resource_id,
      product: product,
    };
    return this.http
      .put("/api/product_request/update", options)
      .pipe(tap((_) => console.log("ProductRequestService.update: Ok.")));
  }
}
